const fallbackTranslations = {
    addAnswerPlaceholder: 'Enter an answer...',
    ajaxError: 'An error occurred.',
    attendanceStatus: 'Attendance status',
    categoryAbsent: 'Absent',
    categoryPresent: 'Present',
    checkSelectedVoices: 'Check selected voices.',
    confirmDeleteAnnouncement: 'Are you sure you want to delete this announcement?',
    confirmDeletePoll: 'Are you sure you want to delete this poll?',
    confirmDeletePollWarning: 'Warning: All answers and poll-related data will be deleted. This operation cannot be undone.',
    confirmThresholdsConflict: 'The new threshold set will apply from today. You already have a partially checked event today. Continuing will remove all checks in today\'s events!',
    dateRangeInvalid: 'The second date must be later!',
    declarationSet: 'The declaration has been set.',
    declarationSetBy: 'Declaration set by: ',
    day: 'day',
    defaultVoicePlaceholder: 'Select a voice...',
    downloadFile: 'Download file',
    errorLabel: 'Error: ',
    eventDate: 'Event date',
    eventName: 'Event name',
    exportCompleted: 'Export completed successfully!',
    exportDeleted: 'The previous export has expired or was deleted. Start a new export.',
    exportFailed: 'Export failed: ',
    exportStartError: 'Error while starting export',
    exportStartedError: 'An error occurred while starting export',
    exportStarting: 'Starting...',
    exportTimeoutHint: 'Try again using the button above or contact the administrator.',
    exportTimeoutTitle: 'Maximum export time exceeded',
    generatingFile: 'Generating file...',
    invalidThresholdRow: 'Both name and value must be filled before adding a new threshold.',
    loading: 'Loading...',
    fridayShort: 'Fri',
    list: 'list',
    mondayShort: 'Mon',
    month: 'month',
    namePlaceholder: 'Name',
    newVoiceLabel: 'New voice: "%(voice)s"',
    noOptionVotes: 'No votes for this option',
    notAllSongsHaveTimes: 'Not all songs have a duration!',
    notSet: 'Not set',
    pollFormLoadError: 'An error occurred while loading the form',
    pollLoadingError: 'Error while loading the poll',
    pollSkipError: 'An error occurred while skipping the poll',
    pollVoteError: 'An error occurred while voting',
    pollVotingFormLoadError: 'Error while loading the voting form',
    queuePending: 'The task is waiting in the queue...',
    removeTitle: 'remove',
    saveVoicesError: 'Error saving voices.',
    saturdayShort: 'Sat',
    saving: 'Saving...',
    selectMembers: 'Select members...',
    selectNewOrExistingVoice: 'Select an existing voice or add a new one',
    selectVoiceRequired: 'Please select a voice',
    selectVoices: 'Select voices...',
    serverError: 'An unknown server error occurred.',
    showMore: 'Show more',
    startExport: 'Start export',
    sundayShort: 'Sun',
    tableExistingOptionHint: 'Existing option - you can only reorder or delete it',
    tableExistingOptionReadonlyTitle: 'The text of an existing option cannot be edited',
    tableReorderTitle: 'change order',
    timezoneWarning: 'Ensemble time zone: %(timezone)s',
    thursdayShort: 'Thu',
    today: 'today',
    totalVotes: 'Total votes: %(count)s',
    userDateRequired: 'Please select a date.',
    userNetworkOrServerError: 'Network or server error: %(error)s',
    votersLoadError: 'Error while loading voters list',
    votersLoadingError: 'An error occurred while loading voters list',
    tuesdayShort: 'Tue',
    weightPlaceholder: 'Weight',
    wednesdayShort: 'Wed',
    week: 'week',
    whoDidNotVoteCount: 'Number of people who did not vote: %(count)s',
    whoDidNotVoteLoadError: 'Error while loading the list of people who did not vote',
    whoDidNotVoteLoadingError: 'An error occurred while loading the list of people who did not vote',
    allEligibleVoted: 'All eligible people voted!',
    nextPoll: 'Next poll',
    close: 'Close',
    concert: 'Concert',
    confirm: 'Confirm',
    rename: 'Rename',
    mediaUrlRequired: 'Enter a web address.',
    mediaUrlInvalid: 'Enter a valid web address, e.g. https://example.com or www.example.com.',
    mediaSaveError: 'Could not save the media item.',
    mediaCategoryNameRequired: 'Category name is required.',
    mediaCategoryNameTooLong: 'Category name can have at most 120 characters.',
    mediaNoCategories: 'No categories.',
    mediaAdd: 'Add media',
    mediaEdit: 'Edit media',
    mediaCategoryAdded: 'A new category was added.',
    mediaCategoryAddError: 'Could not add the category.',
    mediaCategoryRenamed: 'The category was renamed.',
    mediaCategoryRenameError: 'Could not rename the category.',
    mediaConfirmDeleteCategory: 'Are you sure you want to delete this category?',
    mediaCategoryDeleted: 'The category was deleted.',
    mediaCategoryDeleteError: 'Could not delete the category.',
    mediaConfirmDelete: 'Are you sure you want to delete this media item?',
    mediaDeleted: 'The media item was deleted.',
    mediaDeleteError: 'Could not delete the media item.',
    mediaSelectOrAddCategory: 'Select a category or add a new one.',
    mediaAddedFiltersReset: 'The media item was added. Filters were reset.',
    mediaUpdated: 'The media item was updated.',
    mediaAdded: 'The media item was added.',
};

export function t(key) {
    const translationsElement = document.getElementById('frontend-translations');
    return translationsElement?.dataset[key] || fallbackTranslations[key] || key;
}

export function interpolate(message, replacements = {}) {
    return Object.keys(replacements).reduce((result, key) => (
        result.replace(new RegExp(`%\\(${key}\\)s`, 'g'), replacements[key])
    ), message);
}

// Language prefix of the current page ('' for the default language, e.g. '/en'), so that requests stay in its language
export function urlPrefix() {
    return document.documentElement.dataset.urlPrefix || '';
}
